import { render, staticRenderFns } from "./chat-window-avatar.vue?vue&type=template&id=0a40b9c4&scoped=true&"
import script from "./chat-window-avatar.vue?vue&type=script&lang=js&"
export * from "./chat-window-avatar.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-avatar.vue?vue&type=style&index=0&id=0a40b9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40b9c4",
  null
  
)

export default component.exports